exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.boton-focus:focus {\n\tbackground: yellow;\n}\n.span {\n\twidth:100px;\n\tmargin:2px;\n\tpadding: 3px;\n\tborder-radius: 10px;\n\ttext-align: left;\n}\n.boton {\n\twidth:210px;\n\tmargin: 0px 2px 1px 10px;\n\tpadding: 3px;\n\tborder-radius: 10px;\n\ttext-align: left;\n}\n.condicional {\n\tcolor:blue;\n}\n", ""]);

// exports
